const API_URL =
  process.env.REACT_APP_NODE_BACKEND_URL || "http://localhost:3000";

const API_KEY = process.env.REACT_APP_API_KEY;

const createContacts = async (data) => {
  console.log("Sending contact data:", data);

  const response = await fetch(`${API_URL}/contacts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    },
    body: JSON.stringify(data),
  });

  let result;

  try {
    result = await response.json();
  } catch (err) {
    result = {};
  }

  console.log("Backend response:", result);

  if (!response.ok) {
    throw new Error(
      result.error ||
        result.message ||
        `Request failed with status ${response.status}`,
    );
  }

  return result;
};

export default {
  createContacts,
};
